import { cn } from '@/utils/cn';

interface BrandSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE_CLASS = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-10 h-10',
} as const;

export function BrandSpinner({ size = 'md', className }: BrandSpinnerProps) {
  return (
    <img
      src="/icons/logo.svg"
      alt=""
      aria-hidden="true"
      className={cn('animate-spin rounded-full', SIZE_CLASS[size], className)}
    />
  );
}

BrandSpinner.displayName = 'BrandSpinner';
